import { toAbsoluteUrl } from "../../../helpers/AssetHelpers/AssetHelpers";
import { IQuote } from "../../../models/QuoteData";

export const PROVIDER_LOGO_MAP: Record<string, string> = {
  aviva: "Aviva.png",
  "legal & general": "LegalAndGeneral.png",
  "legal and general": "LegalAndGeneral.png",
  "lv=": "LV=.png",
  lv: "LV=.png",
  "canada life": "CanadaLife.png",
  "scottish widows": "ScottishWidows.png",
  "standard life": "StandardLife.png",
  just: "JUST.png",
  "just retirement": "JustRetirement.png",
  prudential: "Prudential.png",
};

export function getProviderLogo(providerName?: string): string | null {
  if (!providerName) return null;
  const file = PROVIDER_LOGO_MAP[providerName.toLowerCase().trim()];
  return file ? toAbsoluteUrl(`/media/providers/${file}`) : null;
}

export function formatCurrency(amount: number | string | undefined): string {
  const value = typeof amount === "string" ? Number(amount) : amount;
  if (!value || Number.isNaN(value)) return "£0";
  return value.toLocaleString("en-GB", {
    style: "currency",
    currency: "GBP",
    maximumFractionDigits: 0,
  });
}

const RECENT_QUOTE_WINDOW_MS = 5 * 24 * 60 * 60 * 1000; // 5 days

export function getTopQuotes(quotes: IQuote[]): {
  lifetime: IQuote | null;
  fixedTerm: IQuote | null;
} {
  const now = Date.now();
  const recentQuotes = quotes.filter((quote) => {
    if (!quote.createdDate) return false;
    const createdTime = new Date(quote.createdDate).getTime();
    return (
      !Number.isNaN(createdTime) && now - createdTime <= RECENT_QUOTE_WINDOW_MS
    );
  });

  const getHighest = (productName: string): IQuote | null =>
    recentQuotes.reduce<IQuote | null>((best, quote) => {
      if (quote.productName?.toLowerCase() !== productName.toLowerCase()) {
        return best;
      }

      const currentAmount = Number(quote.annuityAmountPA ?? 0);
      const bestAmount = Number(best?.annuityAmountPA ?? 0);

      return !best || currentAmount > bestAmount ? quote : best;
    }, null);

  return {
    lifetime: getHighest("Lifetime Annuity"),
    fixedTerm: getHighest("Fixed Term Annuity"),
  };
}

export function getTaxFreeCashDescription(
  taxFreeCashTypeId: string | number | undefined
): string {

  switch (String(taxFreeCashTypeId ?? "")) {
    case "5907":
      return "Based on maximum (25%) tax free cash already taken.";
    case "5904":
    default:
      return "Based on taking maximum (25%) tax free cash.";
  }
}
